import { palette } from '$tablet-app/src/app/theme';
import { Text } from '@akin-home/text/native';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import styled from 'styled-components/native';

interface Props {
  icon: IconProp;
  text?: string;
}

const RecipeSimpleDetail = (props: Props) =>
  props.text ? (
    <Detail>
      <FontAwesomeIcon size={20} icon={props.icon} color={palette.dim} />

      <Text weight="bold">{props.text}</Text>
    </Detail>
  ) : null;

const Detail = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export default RecipeSimpleDetail;
